module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAj0lEQVR4Ae3WAQYCQQCF4b9usCjNbTtIqCu0uk8wG9o9QdULRBlrMDMW3v8O8AE83F/OBXpGNLM9hXVElKwicUCoJXFFbYkHqrKRnl0xkNmNri0gTiQ9qwL3eaCwL7EA8MoBBt45wIAKAQMGVjnAwDoHGICIKi6SdGx9W7YMqNIGNpAWuDChwk2cCTjnfvoAPkQW3lPSWeEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Menucontainer/baseline_folder_open_black_24dp.png
// module id = 62
// module chunks = 0